export function captionEdgeFrames(
  timing: { startFrame: number; durationInFrames: number; syncLeadMs: number },
  index: number,
  pageCount: number,
  duration: number,
  fps: number,
  hold?: { left?: boolean; right?: boolean },
) {
  const start =
    hold?.left && index === 0
      ? Math.min(0, timing.startFrame)
      : timing.startFrame;
  const end =
    hold?.right && index === pageCount - 1
      ? Math.max(duration, timing.startFrame + timing.durationInFrames)
      : timing.startFrame + timing.durationInFrames;
  return {
    startFrame: start,
    durationInFrames: end - start,
    syncLeadMs: timing.syncLeadMs + ((timing.startFrame - start) / fps) * 1000,
  };
}
